module.exports = __webpack_public_path__ + "img/filter-availability.8ccbb313.svg";